import { Page } from "@/models/page-models/Page";

export const SalesContractMaster: Page = {
  "path": "sales-contract-master",
  "name": "Sales Order Master",
  "props": {
    "data": {
      "title": "Sales Order",
      "printable": "FALSE",
      "url": "sales-contract-master",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Open SO",
              "bracketValueFormula": "{{fetchedData.openSalesContracts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Open Sales Order",
                      "disabled": "FALSE",
                      "items": "fetchedData.openSalesContracts.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "ID",
                          "type": "url",
                          "url": "/view-sales-contract/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.customer.assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.orders",
                          "text": "Total Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                          "width": 100
                        },
                        {
                          "value": "balanceValue",
                          "text": "Balance Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id))"
                        },
                        {
                          "value": "balancePercent",
                          "text": "Balance %",
                          "type": "formula",
                          "formula": "fn(CONCAT,fn(HELPER_FN,numFormat,fn(MULTIPLY,fn(DIVIDE,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id)),100),true),%)"
                        },
                        {
                          "value": "__item.dateRange.startDate",
                          "text": "Contract Start",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.startDate}})"
                        },
                        {
                          "value": "__item.dateRange.endDate",
                          "text": "Contract Expiry",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.endDate}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.openSalesContractForm.page",
                        "serverItemsLengthVariable": "fetchedData.openSalesContracts.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getOpenSalesContracts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sales-contract/open",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.openSalesContracts",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.openSalesContractForm"
                            },
                            "name": "getOpenSalesContracts"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.openSalesContracts.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Closed SO",
              "bracketValueFormula": "{{fetchedData.closedSCs.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Closed SC",
                      "disabled": "FALSE",
                      "items": "fetchedData.closedSCs.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "ID",
                          "type": "url",
                          "url": "/view-sales-contract/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.customer.assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.orders",
                          "text": "Total Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                          "width": 100
                        },
                        {
                          "value": "balanceValue",
                          "text": "Balance Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id))"
                        },
                        {
                          "value": "balancePercent",
                          "text": "Balance %",
                          "type": "formula",
                          "formula": "fn(CONCAT,fn(HELPER_FN,numFormat,fn(MULTIPLY,fn(DIVIDE,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id)),100),true),%)"
                        },
                        {
                          "value": "__item.dateRange.startDate",
                          "text": "Contract Start",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.startDate}})"
                        },
                        {
                          "value": "__item.dateRange.endDate",
                          "text": "Contract Expiry",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.endDate}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "pagination": {
                        "pageVariable": "fetchedData.closedScForm.page",
                        "serverItemsLengthVariable": "fetchedData.closedSCs.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.closedScForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getClosedSCs",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/quotation/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.closedSCs",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.closedScForm"
                            },
                            "name": "getClosedSCs"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOpenSalesContractForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOpenSalesContractForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.openSalesContractForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultOpenSalesContractForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getOpenSalesContracts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sales-contract/open",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.openSalesContracts",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.openSalesContractForm"
        },
        "name": "getOpenSalesContracts"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultClosedScForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultClosedScForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.closedScForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultClosedScForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getClosedSCs",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.closedSCs",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.closedScForm"
        },
        "name": "getClosedSCs"
      }
    ],
    "functions": [
      {
        "name": "getDefaultOpenSalesContractForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "getDefaultClosedScForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "SC Cancelled",
              "SC Completed"
            ]
          }
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "CUSTOMER_SERVICE_MANAGER",
  "visible": true,
  "routerPriority": 74
}